module.exports = __webpack_public_path__ + "placeholder.b7d1efffcf3d3b54b66b2d3d8b34e690.jpg";